import React from 'react';
import styles from 'styles/layout/CareerMainSection.module.sass';

/**
 * CareerMainSection component renders the main content section of the Career page.
 *
 * This section includes:
 * - A header with a subtitle indicating that there are no current job openings.
 * - A paragraph encouraging visitors to check back later for updates.
 * - An image related to work or careers.
 *
 * @component
 *
 * @example
 * // Example usage of the CareerMainSection component
 * import CareerMainSection from 'components/layout/team/CareerMainSection';
 *
 * const App: React.FC = () => (
 *   <CareerMainSection />
 * );
 *
 * export default App;
 */
const CareerMainSection: React.FC = () => (
  <section className={styles['main-section']}>
    <div className={styles['main-content']}>
      <div className={styles['main-text']}>
        <h3 className={styles['subtitle']}>We are Not Hiring Right Now — But Stay Tuned</h3>
        <p className={styles['paragraph']}>
          We don&apos;t have any open roles at the moment, but we&apos;re always looking for great
          talent. Check back soon or follow us for updates.
        </p>
      </div>
    </div>
    <div className={styles['image-container']}>
    </div>
  </section>
);

export default CareerMainSection;